import { render, staticRenderFns } from "./StaffMainPage.vue?vue&type=template&id=5b889164&scoped=true"
import script from "./StaffMainPage.vue?vue&type=script&lang=js"
export * from "./StaffMainPage.vue?vue&type=script&lang=js"
import style0 from "./StaffMainPage.vue?vue&type=style&index=0&id=5b889164&prod&scoped=true&lang=css"
import style1 from "./StaffMainPage.vue?vue&type=style&index=1&id=5b889164&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b889164",
  null
  
)

export default component.exports